import React from 'react';
import '../styles/SuccessModal.css';

const SuccessModal = ({ message, onClose, icon, iconColor, classSet="" }) => {
    return (
        <div className={`modal-overlay ${classSet}`}>
            <div className="modal-content">
                <i className={`fa-regular fa-circle-${icon} font-${iconColor} modal-icon`}></i>
                <p className="modal-message male-female-stat">{message}</p>
                <button className="modal-button" onClick={onClose}>OK</button>
            </div>
        </div>
    );
};

export default SuccessModal;
